import { render, staticRenderFns } from "./BrokerEntityForm.vue?vue&type=template&id=6b157fbd&scoped=true&"
import script from "./BrokerEntityForm.vue?vue&type=script&lang=js&"
export * from "./BrokerEntityForm.vue?vue&type=script&lang=js&"
import style0 from "./BrokerEntityForm.vue?vue&type=style&index=0&id=6b157fbd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b157fbd",
  null
  
)

export default component.exports